var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturingDefectsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E77B7B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57812 19.597V18.385H10.8446L8.90437 12.0362C8.57637 11.8777 8.31512 11.6507 8.12062 11.3552C7.92562 11.0602 7.82812 10.721 7.82812 10.3375C7.82812 9.818 8.01087 9.3755 8.37637 9.01C8.74187 8.6445 9.18437 8.462 9.70387 8.4625C10.1624 8.4625 10.5559 8.603 10.8844 8.884C11.2129 9.165 11.4329 9.5245 11.5444 9.9625H14.2894V8.4625H14.9494L15.0056 8.935L16.7029 7.375L20.2714 9.0535L19.9939 9.6385L16.8311 8.1625L15.0401 9.8125V10.8625L16.8311 12.475L20.0036 10.9975L20.2796 11.5833L16.7029 13.2708L15.0056 11.7392L14.9359 12.2118H14.2901V10.7118H11.5429C11.5054 10.8792 11.4431 11.0453 11.3561 11.2098C11.2691 11.3743 11.1736 11.5113 11.0696 11.6207L14.7049 18.3857H17.5774V19.5963L8.57812 19.597ZM9.70312 11.4625C10.0116 11.4625 10.2761 11.352 10.4966 11.131C10.7176 10.9105 10.8281 10.646 10.8281 10.3375C10.8281 10.0285 10.7176 9.7635 10.4966 9.5425C10.2761 9.3225 10.0116 9.2125 9.70312 9.2125C9.39462 9.2125 9.12963 9.3225 8.90813 9.5425C8.68813 9.7635 8.57812 10.0285 8.57812 10.3375C8.57812 10.646 8.68813 10.9105 8.90813 11.131C9.12912 11.352 9.39412 11.4625 9.70312 11.4625ZM11.6329 18.385H13.8454L10.4471 12.0678C10.3701 12.1158 10.2614 12.1568 10.1209 12.1908C9.98038 12.2248 9.85262 12.232 9.73763 12.2125L11.6329 18.385Z",
    fill: "#E77B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturingDefectsIcon);
export default __webpack_public_path__ + "static/media/ManufacturingDefectsIcon.ac53bb1b1a34f61c92e432a5786cffc4.svg";
export { ForwardRef as ReactComponent };